<template>
  <div>
    <h2>Concepts 图层概念</h2>
    <p>引用一张图片来形容：</p>
    <p><img src="/static/img/layer1.jpg" alt="图层"></p>
    <p>图层就像堆叠在一起的透明纸，每一张(图层)上都保存着不同的图像；</p>
    <p>我们可以透过上面图层的透明区看到下面层中的图像；</p>
    <p>每个图层中的对象都会单独处理，不会影响其他图层中的内容；</p>
    <p>图层可以调整位置、堆叠顺序。</p>
    <h3>图层展示</h3>
    <vue-form :model="form" :layer="layer">
      <vue-form-line :cols="[{ span: 12, label: '图层展示', prop: '/form/layer' }]">
        <el-input v-model="form.layer" />
      </vue-form-line>
    </vue-form>
  </div>
</template>

<script>
export default {
  data() {
    var whyGrrenTP = data => {
      return (
        <div>
          <p>title: {data.title}</p>
          <p>content: {data.content}</p>
        </div>
      );
    };
    var tableTP = data => {
      return (
        <el-table data={data}>
          <el-table-column prop="placement" label="placement" width="80" />
          <el-table-column prop="target" label="target" width="120" />
          <el-table-column prop="template" label="template" width="120" />
          <el-table-column prop="enterable" label="enterable" width="120" />
        </el-table>
      );
    };
    var codeTarget = () => {
      return <div>&lt;&gt;</div>;
    };
    var codeTP = data => {
      return (
        <div>
          <p>code template:</p>
          <img src={data.templateImg} alt="code template" />
          <p>code script:</p>
          <img src={data.scriptImg} alt="code template" />
        </div>
      );
    };
    var targetFn = () => {
      return <i class="el-icon-document" />;
    };
    return {
      form: {
        layer: ""
      },
      layer: [
        {
          data: [
            {
              prop: "/form/layer",
              data: "effect: #f8911b, visibleArrow: false",
              effect: "#f8911b",
              visibleArrow: false
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: "effect: dark, placement: right",
              effect: "dark",
              placement: "right"
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: [
                {
                  placement: "left",
                  target: "custom target",
                  template: "custom template",
                  enterable: "false",
                  data: "array"
                },
                {
                  placement: "left",
                  target: "custom target",
                  template: "custom template",
                  enterable: "false",
                  data: "array"
                }
              ],
              template: tableTP,
              placement: "left"
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: "custom effect: red",
              effect: "red"
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: {
                title: "custom effect: #b55547",
                content: "placement: top, data: object"
              },
              effect: "#b55547",
              placement: "top",
              template: whyGrrenTP
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data:
                "custom effect: #5457a6, placement: bottom, enterable: true",
              effect: "#5457a6",
              placement: "bottom",
              enterable: true
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: "custom effect: #409eff, placement: right",
              effect: "#409eff",
              placement: "right"
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: "type: text, effect: '#42b983'",
              type: "text",
              effect: "#42b983"
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: {
                title: "target why",
                content: "custom effect: #42b983, custom template, data: object"
              },
              target: "why",
              effect: "#42b983",
              template: whyGrrenTP
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: [
                {
                  placement: "right",
                  target: "custom target",
                  template: "custom template",
                  enterable: "true",
                  data: "array"
                },
                {
                  placement: "right",
                  target: "custom target",
                  template: "custom template",
                  enterable: "true",
                  data: "array"
                }
              ],
              placement: "right",
              target: targetFn,
              template: tableTP,
              enterable: true
            }
          ]
        },
        {
          data: [
            {
              prop: "/form/layer",
              data: {
                templateImg: "/static/img/tp.png",
                scriptImg: "/static/img/code-script.gif"
              },
              target: codeTarget,
              template: codeTP,
              enterable: true
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/layer/concepts.vue